<script>
  import _ from 'lodash'
  import cloudinary from 'cloudinary-core'
  import { config_obj } from '../utils/firebase.js'
  const cloudinary_config = {
    cloud_name: config_obj.cloudinary_cloud_name,
    cdn_subdomain: true,
    secure: true
  }

  export default {
    data() {
      return {
        cloudinary_config,
        cl: {}
      }
    },
    created() {
      this.init_cloudinary()
    },
    mounted() {
      this.cl_responsive()
    },
    methods: {
      init_cloudinary() {
        return this.cl = cloudinary.Cloudinary.new(this.cloudinary_config)
      },
      cl_responsive: _.debounce(
        function() {
          this.cl.responsive()
        },
        500
      )
    }
  }
</script>
